// Initialize Locales
import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

// see http://kazupon.github.io/vue-i18n/api/
// export default new VueI18n({
//   locale: 'de',
//   // fallbackLocale: 'en',
//   messages: {
//     en: require('./en.js'),
//     de: require('./de.js')
//   }
// });

const en = require('./en.js');
const de = require('./de.js');

export function setupI18n(customLocales) {
  const messages = { en, de, };

  deepMerge(messages, customLocales);

  console.log(messages);
  return new VueI18n({
    locale: 'de',
    // fallbackLocale: 'en',
    messages: messages
  });
}

function deepMerge(obj1, obj2) {
  if (obj2) {
    Object
      .keys(obj2)
      .forEach(k => {
         if (obj2[k] instanceof Object && obj1[k] instanceof Object) {
           deepMerge(obj1[k], obj2[k]);
         } else {
           obj1[k] = obj2[k];
         }
      });
  }
}